import {
  WORKER_UPDATE,
  POP_FETCH_QUEUE,
  REGISTER_WORKER,
  WORKER_CLAIM_TASK
} from '../constants/worker-constants'
import fetch from 'isomorphic-fetch'

/* Lightweight Prefetch Queue system */
export const fetchSingle = (url, workerId) => {
  return (dispatch => {
    fetch(url, {mode: 'no-cors'})
    .then(response => {
      console.log(`Fetched with status OK ${response.ok}: ${url}`)
      return response
    })
    .then(response => dispatch(setWorkerAsIdle(workerId)))
  })
}

/*
   Pops out the first item from the queue. See reducer.
 */
const popFetchQueue = () => {
   return (dispatch => {
      dispatch({
         type: POP_FETCH_QUEUE
      })
   })
}

/*
   A worker uses this to request a task when it is idle. Assumes that
   the worker has checked that it is capable of taking on a new task.

   This works by first grabbing an item to process from the queue, 
   then dispatching an action to remove it from the queue (so that 
   no other workers get it by accident). Then the task is assigned
   to the requesting worker.
 */
export const workerRequestTask = (workerId) => {
   return ((dispatch, getState) => {
      // grab a queue task, remove from queue, assign to worker
      const queue = getState().journey.getIn(['fetchQueue', 'queue'])
      if (queue.size > 0) {
         const task = queue.get(0)
         dispatch(popFetchQueue())
         dispatch(assignTaskToWorker(workerId, task))
      }
   })
}

/*
   Register a worker. Sets up the default worker state in the redux store.
   workerId should be an integer, which is used as an index
 */
export const registerWorker = (workerId) => {
   return (dispatch => {
      dispatch({
         type: REGISTER_WORKER,
         payload: { workerId }
      })
   })
}

export const workerClaimTask = (workerId) => {
   return (dispatch => {
      dispatch({
         type: WORKER_CLAIM_TASK,
         payload: {
            workerId, 
            status: 'working'
         }
      })
   })
}

/*
   Assigns a task to a worker. See the reducer.
 */
const assignTaskToWorker = (workerId, task) => {
   return (dispatch => {
      dispatch({
         type: WORKER_UPDATE,
         payload: {
            status: 'waiting',
            task,
            workerId,
         }
      })
   })
}


const setWorkerAsIdle = (workerId) => {
   return (dispatch => {
      dispatch({
         type: WORKER_UPDATE,
         payload: {
            workerId, 
            status: 'idle', 
            task: null}
      })
   })
}


// WEBPACK FOOTER //
// ./src/actions/worker-actions.js